import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    FormGroup,
    Label,
    Input,
    FormFeedback,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../../assets/svg/move.svg';
import moreIcon from '../../../assets/svg/more.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import xIcon from '../../../assets/svg/x.svg';
import noNotifications from '../../../assets/svg/no-notif.svg';

import notesIcon from '../../../assets/svg/notes-icon.svg';

import PatientNotesPreview from '../../../components/patientNotesPreview';


import moment from 'moment';
import { API_ENDPOINT, getAgeLimit, translateAgeLimitMessage } from '../../../constants';
import ErrorModal_v2 from '../../../components/errorModal_v2';
import CustomSelectWithSearch from '../../../components/forms/fields/customSelectWithSearch';
import Checkbox from '../../../components/forms/fields/checkbox';
import DatePicker from '../../../components/forms/fields/datePicker';
import TimePickerV2 from '../../../components/forms/fields/timepicker_v2';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import EventMeetingsModal from '../../../components/eventMeetingsModal';
import SelectWithCheckbox from '../../../components/forms/fields/selectWithCheckbox';
import { isStringAValidNumber } from '../../../components/TwoFactorAuthModal';
import ErrorModal from '../../../components/errorModal';

import striptags from 'striptags';
import DoctorListComponent from '../../../components/forms/fields/doctorListComponent';
import InfoModal from '../../../components/infoModal';
import PatientModal from './patientModal';
import AddSecondParentModal from '../../../components/addSecondParentModal';
import { addMinutesToTime } from '../helper';
import PaymentMethodsField from '../../payments/components/paymentMethodsField';
import { getExtendedPaymentManagement } from '../../payments/helper';
import { checkRescheduleData } from '../../egenRemiss/helper';

function isTimeValidString(timeString) {
    let valid = false;
    if (timeString?.length === 5) {
        const [hours, minutes] = timeString.split(":").map((x) => parseInt(x, 10));
        if (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
            valid = true;
        }
    }


    return valid;
}


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
function truncateString(str) {
    if (str.length > 210) {
        return str.substring(0, 210) + '...';
    }
    return str;
}

class RescheduleAdministrativeBooking extends React.Component {

    constructor(props) {
        super(props);

        this.player = React.createRef();
        this.state = {
            ...props.initialData,
            doctors: [],
            languages: [],
            clinicians: [],
            minTime: '07:00',
            maxTime: '18:00',

        }
        this.state.min = new Date();
        this.state.min.setHours(7, 0, 0)
        this.state.max = new Date();
        this.state.max.setHours(18, 0, 0)

    }

    generateInitialTime = () => {
        let tsNow = Math.floor(new Date().getTime() / 1000);
        const interval = 10 * 60;
        const ts = Math.ceil(tsNow / interval) * interval;

        let date = moment.unix(ts).format(this.props.dateFormat);
        let startTime = moment.unix(ts).format('HH:mm');
        let endTime = moment.unix(ts + 60 * 5).format('HH:mm');

        let data = {
            date,
            endDate: date,
            startTime,
            endTime,
            title: ''
        }

        return data;
    }
    getDoctors = (callback) => {
        let query = {
            // entries: 10,
            // page: 0,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
            // doctor: this.state.doctorId,
            // filter: this.state.searchVisitReason ? this.state.searchVisitReason : this.state.selectRevisitForm ? this.state.searchRevisitForm : '',
            // day: this.state.day ? this.state.day : new Date(),
            // view: this.state.view
        };
        let queryFields = {};
        for (var key in query) {
            if (key && key.indexOf('query-') === 0) {
                queryFields[key.replace('query-', '')] = query[key];
            }
        }

        fetch(API_ENDPOINT + '/users/subaccounts/doctors', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                page: null,
                entries: null,
                filter: query.filter,
                sortType: query.sortType,
                sortField: query.sortField,
                groupId: query.group,
                clinic: query.clinic,
                query: queryFields
            })
        }).then(res => res.json()).then((result) => {
            if (result) {
                this.setState({ doctors: result }, () => {
                    if (callback) callback();
                })
            } else {
                if (callback) callback();
            }
        })


    }
    getClinicians = () => {
        const clinicId = this.props.selectedClinic;
        if (!clinicId) return;

        this.setState({ clinicians: [] }, () => {
            fetch(API_ENDPOINT + `/data/calendar/doctors/${clinicId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.clinicians?.length) {
                    this.setState({ clinicians: result.clinicians });
                }
            })
        });
    }

    checkPatientNotes = async (referralId) => {
        if (!referralId) {
            return [];
        }
        let data = {
            referralId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };
        let result = await fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        try {
            let response = await result.json();
            if (response?.items?.length) {
                return response.items;
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching patient notes:', error);
            return [];

        }
    }

    setInitialData = async () => {
        const groupData = this.getGroupData();
        this.setState({ groupData: groupData });

        const adminPermissionId = this.props.uData?.permissions?.admin;
        const doctorPermissionId = this.props.uData?.permissions?.doctor;
        const schedulerPermissionId = this.props.uData?.permissions?.scheduler;
        const groupId = this.props.selectedGroup ?? groupData?._id ?? null;
        const clinicId = this.props.selectedClinic;

        let doctorId, disabledDoctorSelect = false;

        const groupPermissionsUser = this.props.uData?.groupPermissionsUser;
        const isAdmin = groupPermissionsUser?.[groupId]?.[clinicId]?.indexOf(adminPermissionId) !== -1 || groupPermissionsUser?.[groupId]?.[clinicId]?.indexOf(schedulerPermissionId) !== -1 ? true : false;

        let data = this.props.isOpen;

        let initialTime = this.generateInitialTime();

        data.date = initialTime.date;
        data.startTime = initialTime.startTime;
        data.endTime = initialTime.endTime;

        if (!isAdmin) {
            doctorId = this.props.uData._id;
            disabledDoctorSelect = true;
        }

        let referralId = data?._id;
        if (referralId) {
            let patientNotes = await this.checkPatientNotes(referralId);
            if (patientNotes && patientNotes.length) {
                data.patientNotes = patientNotes;
            }
        }

        data = await checkRescheduleData(data, this.props)

        if (data?.event?.patientNote) {
            data.patientNote = data?.event?.patientNote;
        }


        let setObj = {
            data: data,
            disabledDoctorSelect: disabledDoctorSelect,
            doctorId: doctorId
        }

        if (data?.rescheduledData?.doctorId && this.state.doctors?.find(el => el._id === data?.rescheduledData?.doctorId)) {
            setObj.doctorId = data?.rescheduledData?.doctorId;
        }
        console.log('setObj', setObj);
        this.setState(setObj, () => {
            this.getWorkingHours();
            this.getClinicians();
        })
    }
    getLanguages = () => {

        fetch(API_ENDPOINT + '/languages', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sortType: 1,
                sortField: 'key',
                query: {}
            })
        }).then(parseJSON).then(({ result, status }) => {
            if (result) {
                this.setState({ languages: result })
            }
        })

    }
    googleHolidayEvents = () => {
        const groupId = this.props.selectedGroup;
        if (!groupId) return;

        this.setState({ holidayEvents: [] }, () => {

            fetch(API_ENDPOINT + '/google/holidays/events/' + groupId, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
            }).then(res => res.json()).then((result) => {
                if (result?.items?.length) {
                    let holidayEvents = [...result.items]
                    for (let i = 0; i < holidayEvents.length; i++) {
                        if (holidayEvents[i].date) {
                            let _start = `${holidayEvents[i].date} 08:00`;
                            let _end = `${holidayEvents[i].date} 17:00`;
                            holidayEvents[i].startTime = Math.floor(new Date(_start).getTime() / 1000);
                            holidayEvents[i].endTime = Math.floor(new Date(_end).getTime() / 1000);
                        }
                    }
                    this.setState({ holidayEvents })
                }
            })
        })

    }
    componentDidMount() {

        this.getDoctors(() => {
            this.setInitialData();
        })

        this.googleHolidayEvents();

    }
    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        let groupData = this.props?.uData?.clinicGroups?.[selectedGroupIdx];

        return groupData;
    }
    toggle = (doubleToggle, caseData = null) => {
        if (this.props.toggle) {
            this.props.toggle(doubleToggle, caseData);
        }

    }
    getWorkingHours = () => {
        const doctorId = this.state.doctorId;
        const clinicId = this.props.selectedClinic;
        const groupId = this.props.selectedGroup;

        if (!doctorId || !clinicId || !groupId) return;

        const obj = {
            clinicianId: doctorId,
            clinicId: clinicId,
            groupId: groupId
        };

        fetch(API_ENDPOINT + `/data/calendar/clinician/working-hours`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(parseJSON).then(({ result, status }) => {

            let { minTime, maxTime } = result;
            if (!minTime) minTime = '07:00';
            if (!maxTime) maxTime = '18:00';

            let setObj = {};
            if (minTime !== this.state.minTime) {
                setObj.minTime = minTime;
            }
            if (maxTime !== this.state.maxTime) {
                setObj.maxTime = maxTime;
            }
            if (Object.keys(setObj).length > 0) {
                this.setState(setObj)
            }

        })
    }


    checkDoctorsAvailable = (doctorsList, modal, callback) => {
        let event;
        event = this.state.data;

        if (doctorsList) {
            let data = {
                doctorsList: doctorsList,
                startEventReservedDateOriginal: event.date + ' ' + event.startTime,
                endEventReservedDateOriginal: event.date + ' ' + event.endTime,
                startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(event.date + ' ' + event.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
                eventId: event.id
            }
            fetch(API_ENDPOINT + '/working-hours/check/doctors', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        errorAdditionalDoctors: result.doctorsList
                    })
                } else {
                    this.setState({ doctorsModal: false, successfullyAdditionalDoctors: modal != 4 ? true : false }, () => {

                        let data = this.state.data;
                        data.additionalDoctors = this.state.doctorsList;
                        this.setState({ data })


                    })
                }
                if (callback) {
                    callback();
                }


            })
        }


    }
    setData = (data, callback) => {
        this.setState({ data }, () => {
            if (callback) {
                callback();
            }
        })
    }
    scheduleAdministrativeBooking = (forceInsert = false) => {
        const data = this.state.data;
        const caseId = data?._id;
        const _data = JSON.parse(JSON.stringify(data));
        if (!_data || !caseId) {
            this.setState({ creatingEvent: false });
            return;
        }


        let checkDate = new Date(data?.date?.replace(/-/g, "/") + ' ' + data?.startTime);
        let today = new Date();



        if (checkDate < today && !forceInsert) {
            this.setState({
                wrongDateModal: true
            })
            return;
        } else {
            if (this.state.wrongDateModal) {
                this.setState({ wrongDateModal: null });
            }
        }

        let dataToSend = {
            startEventReservedDateOriginal: data.date + ' ' + data.startTime,
            endEventReservedDateOriginal: data.date + ' ' + data.endTime,
            startEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.startTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            endEventReservedDate: this.props.getStringDateInverseTs(Math.floor(new Date(data.date + ' ' + data.endTime).getTime() / 1000), `${this.props.dateFormat} HH:mm`),
            doctor: this.state.doctorId,
            patientNote: data.patientNote,
            additionalDoctors: data.additionalDoctors,
            guests: data.guests,
        };
        this.setState({ loading: true }, () => {
            fetch(API_ENDPOINT + `/data/calendar/administrative-bookings/reschedule/${caseId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    this.setState({
                        error: result.error.translate(this.props.lang),
                        loading: false,
                        creatingEvent: false
                    })
                } else {
                    this.setState({
                        creatingEvent: false,
                        loading: false,
                    });
                    let caseData = result?.caseData ?? null;

                    this.toggle(true, caseData);
                }


            })
        });


    }
    render() {
        const isOpen = this.state.data ? true : false;
        if (!isOpen) return null;

        const groupData = this.state.groupData;
        const enterprise = groupData?.enterprise;
        const eventMeetings = groupData?.eventMeetings ?? false;

        const doctorId = this.state.doctorId ?? null;
        const disabledDoctorSelect = this.state.disabledDoctorSelect ? true : false;

        const { minTime, maxTime } = this.state;


        const humanReadable = {
            'waiting-for-approval': 'Waiting for approval'.translate(this.props.lang),
            'waiting': 'Waiting'.translate(this.props.lang),
            'waiting-for-payment': 'Waiting for payment'.translate(this.props.lang),
            'disallowed': 'Disallowed'.translate(this.props.lang),
            'in-progress': 'In progress'.translate(this.props.lang),
            'allowed': 'Allowed'.translate(this.props.lang),
            'return-for-update': 'Return for update'.translate(this.props.lang),
            'patient-requested-another-time': 'Patient requested anoother time'.translate(this.props.lang),
            'patient-rejected': 'Cancelled by patient'.translate(this.props.lang), //  'Rejected by patient'.translate(this.props.lang),
            'patient-accepted': 'Patient accepted'.translate(this.props.lang),
            'clinic-accepted-requested-time': 'Clinic accepted requested time'.translate(this.props.lang),
            'clinic-rejected-requested-time': 'Clinic rejected requested time'.translate(this.props.lang),
            'approved-by-region-manager': 'Approved by region manager'.translate(this.props.lang),
            'rejected-by-region-manager': 'Rejected by region manager'.translate(this.props.lang),
            'scheduled': 'Scheduled'.translate(this.props.lang),
            'visit-rescheduled': 'Visit rescheduled'.translate(this.props.lang),
            'revisit-scheduled': 'Revisit scheduled'.translate(this.props.lang),
            'not-booked': 'Cancelled by clinician'.translate(this.props.lang), //'Not booked'.translate(this.props.lang),
            'closed': 'Closed'.translate(this.props.lang),
            'canceled-by-clinic': 'Cancelled by clinician'.translate(this.props.lang), // 'Canceled by clinic'.translate(this.props.lang),
            'requested-new-appointment': 'Requested new appointment'.translate(this.props.lang),
            'external': 'External transfer'.translate(this.props.lang),
            'not-scheduled': 'Not scheduled'.translate(this.props.lang),
        }

        const titleTooltipText = 'Administrative bookings are never seen by the patient. Colleagues can chat/video without the patient. External guests can be invited to video without the patient.'.translate(this.props.lang);

        return (
            <>

                <Modal isOpen={isOpen} centered>
                    <ModalHeader
                        toggle={() => this.toggle()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggle()}>&times;</button>
                        }
                    >
                        <div style={{ display: 'ruby' }}>
                            {'Schedule cancelled administrative booking'.translate(this.props.lang)}
                            <div className="parent-tooltip update-administrative-booking-tooltip">
                                <Isvg src={infoIcon} className="info-text" />
                                <div className="chat-icons-tooltip">
                                    {titleTooltipText}
                                </div>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {
                            !disabledDoctorSelect ?
                                <FormGroup>
                                    <Label>{'Doctor'.translate(this.props.lang) + '*'}</Label>
                                    <Input
                                        type='select'
                                        value={doctorId}
                                        disabled={disabledDoctorSelect}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (value === '-1') value = null;
                                            this.setState({ doctorId: value }, () => {
                                                this.getWorkingHours();
                                                let data = this.state.data;
                                                if (this.state.doctorId && data?.additionalDoctors?.find(el => el === this.state.doctorId)) {
                                                    data.additionalDoctors = data.additionalDoctors.filter(el => el !== this.state.doctorId);
                                                    this.setData(data);
                                                }
                                                if (this.state.doctorId && this.state.doctorsList?.find(el => el === this.state.doctorId)) {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = doctorsList.filter(el => el !== this.state.doctorId);
                                                    this.setState({ doctorsList })
                                                }
                                            })

                                        }}
                                    >
                                        <option value={'-1'}>{'Select doctor'.translate(this.props.lang)}</option>
                                        {
                                            this.state.clinicians.map((item, idx) => {
                                                return (
                                                    <option value={item._id} key={idx}>{item.name}</option>
                                                )
                                            })
                                        }
                                    </Input>
                                </FormGroup>
                                :
                                null
                        }
                        <FormGroup>

                            <Label>{'Patient'.translate(this.props.lang)}</Label>
                            <Input
                                type='text'
                                value={`${this.state.data?.patient?.name}${" " + humanReadable[this.state.data?.status].translate(this.props.lang)}`}
                            />

                        </FormGroup>


                        <DatePicker
                            label={'Date'.translate(this.props.lang)}
                            value={this.state.data.date}
                            holidayEvents={this.state.holidayEvents}
                            onChange={(e) => {
                                let data = this.state.data;
                                data.date = e;
                                this.setState({
                                    data
                                })
                                if (Math.floor(new Date(this.state.data.date + ' ' + this.state.data.startTime) / 1000) > Math.floor(new Date(this.state.data.endDate + ' ' + this.state.data.endTime) / 1000)) {
                                    data.endDate = this.state.data.date
                                    this.setState({
                                        data
                                    })
                                }
                            }}
                        />
                        <div className={this.state.data?.templateData?.selectedAvailabilityTemplate?._id ? 'schedule-control-time-wrap-template' : ''}>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'Start time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.startTime}
                                    minValue={minTime}
                                    maxValue={addMinutesToTime(maxTime, -5)}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.startTime = timeString


                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        } else {
                                            data.endTime = Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60
                                            const padded = data?.endTime?.split?.(':');
                                            if (padded && Array.isArray(padded) && padded.length && isStringAValidNumber(padded[0]) && isStringAValidNumber(padded[1])) {
                                                const h = padded[0]?.padStart?.(2, '0');
                                                const m = padded[1]?.padStart?.(2, '0');
                                                if (h && m) data.endTime = `${h}:${m}`;
                                            }
                                            this.setState({
                                                data
                                            })
                                        }
                                    }}
                                />
                            </FormGroup>
                            <FormGroup className="timepicker-container timepicker-wide">
                                <Label>{'End time'.translate(this.props.lang)}</Label>
                                &nbsp;
                                <TimePickerV2
                                    getStringDateTs={this.props.getStringDateTs}
                                    format={'HH:mm'}
                                    value={this.state.data.endTime}
                                    minValue={Math.trunc((Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) / 60) + ":" + (Number(this.state.data.startTime.split(':')[0]) * 60 + Number(this.state.data.startTime.split(':')[1]) + 5) % 60}
                                    maxValue={maxTime}
                                    flag={0}
                                    onChange={(time1, timeString) => {

                                        let data = this.state.data;
                                        data.endTime = timeString

                                        let startTimeSplit = data.startTime.split(":");
                                        let endTimeSplit = data.endTime.split(":");

                                        let startTimeHourMinute = Number(startTimeSplit[0]) * 60 + Number(startTimeSplit[1]);
                                        let endTimeHourMinute = Number(endTimeSplit[0]) * 60 + Number(endTimeSplit[1]);

                                        if (startTimeHourMinute < endTimeHourMinute) {
                                            this.setState({ data })
                                        }
                                    }}
                                />

                            </FormGroup>
                        </div>
                        <FormGroup>
                            <Label className='note-label-wrap'>{'Note'.translate(this.props.lang)}
                                <div className={this.state?.data?.patientNotes?.length ? 'notes-icon-wrap notes-icon-active' : 'notes-icon-wrap'} onClick={() => { this.setState({ showPatientNotes: true }) }}>
                                    <Isvg src={notesIcon} />
                                    <div className='tooltip-text'>{'Notes available'.translate(this.props.lang)}</div>
                                </div>
                            </Label>
                            <Input type='textarea'
                                name="note"
                                style={{ height: '150px' }}
                                onChange={(e) => {
                                    let data = this.state.data;
                                    data.patientNote = striptags(e.target.value);
                                    this.setState({
                                        data
                                    })
                                }}
                                value={this.state.data.patientNote}
                            />
                        </FormGroup>
                        <div className='calendar-modal-buttons-wrap'>
                            <FormGroup>
                                <Button onClick={() => this.setState({
                                    doctorsModal: 3
                                })} color="primary">
                                    {'Add caregiver'.translate(this.props.lang)}
                                </Button>
                            </FormGroup>
                            <FormGroup>
                                <Button
                                    onClick={() => {
                                        let guests = [];
                                        if (this.state.data?.guests) {
                                            guests = [...this.state.data.guests];
                                        }
                                        this.setState({
                                            eventMeetingsModal: { ...this.state.data, guests, modal: 'administrativeBooking' }
                                        })
                                    }}
                                    color="primary"
                                >
                                    {'Add guest'.translate(this.props.lang)}
                                </Button>
                            </FormGroup>
                        </div>


                        <Button
                            color='primary'
                            disabled={!this.state.creatingEvent && this.state.doctorId ? false : true}
                            onClick={() => this.setState({
                                creatingEvent: true
                            }, () => {
                                this.scheduleAdministrativeBooking();
                            })}
                        >
                            {'Schedule administrative booking'.translate(this.props.lang)}
                        </Button>


                    </ModalBody>
                </Modal >
                {
                    this.state.eventMeetingsModal ?
                        <EventMeetingsModal
                            {...this.props}
                            data={this.state.eventMeetingsModal}
                            doctorId={this.state.doctorId}
                            onClose={() => this.setState({ eventMeetingsModal: null })}
                            closeButtonText={'Close without saving'.translate(this.props.lang)}
                            saveData={(data) => {
                                let setObj = { eventMeetingsModal: null };
                                let modal = this.state.eventMeetingsModal?.modal;
                                console.log('saving event meetings data:', data, modal);
                                if (data && modal) {
                                    if (modal === 'administrativeBooking') {
                                        let eventObj = this.state.data;
                                        eventObj.guests = data;
                                        this.setData(eventObj)
                                    }
                                }
                                this.setState(setObj)
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.successfullyAdditionalDoctors ?
                        <InfoModal
                            isOpen={this.state.successfullyAdditionalDoctors}
                            toggle={() => this.setState({ successfullyAdditionalDoctors: !this.state.successfullyAdditionalDoctors })}
                            header={'Info'.translate(this.props.lang)}
                            info={`All doctors were successfully added`.translate(this.props.lang)}
                            buttons={[
                                <Button color="primary" style={{ margin: 10 }} onClick={() => this.setState({ successfullyAdditionalDoctors: false })}>{'Ok'.translate(this.props.lang)}</Button>,

                            ]}

                        />
                        :
                        null
                }
                {
                    this.state.doctorsModal ?
                        <Modal isOpen={this.state.doctorsModal} centered toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} >
                            <ModalHeader toggle={() => this.setState({ doctorsModal: !this.state.doctorsModal })} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.setState({ doctorsModal: !this.state.doctorsModal })}><Isvg src={xIcon} /></button>}>{'Choose doctors'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody className="run-modal">

                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <FormGroup >
                                            <Label>{'Search'.translate(this.props.lang)}</Label>
                                            <Input type='text' value={this.state.filterDoctors ? this.state.filterDoctors : ''} onChange={(e) => {
                                                this.setState({
                                                    filterDoctors: e.target.value
                                                })
                                            }} />

                                        </FormGroup>
                                        :
                                        null
                                }

                                <FormGroup >
                                    {
                                        this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                            if (item._id != this.state.doctorId) {
                                                return true;
                                            } else {
                                                return false;
                                            }
                                        }).length ?
                                            <DoctorListComponent

                                                value={this.state.doctorsList ? this.state.doctorsList : []}
                                                values={this.state.doctors.filter(el =>
                                                    (!this.state.updateEvent || (this.state.updateEvent && this.state.updateEvent.patientId != el._id))
                                                    && (!this.state.scheduleReferral || (this.state.scheduleReferral && this.state.referralId && this.state.referrals.filter(ref => ref._id == this.state.referralId) && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0] && this.state.referrals.filter(ref => ref._id == this.state.referralId)[0].patientId != el._id))
                                                    && (!this.state.data || (this.state.data && this.state.data.patient != el._id))
                                                ).sort((a, b) => {
                                                    const nameA = a.name;
                                                    const nameB = b.name;
                                                    if (nameA < nameB) {
                                                        return -1
                                                    }
                                                    if (nameA > nameB) {
                                                        return 1
                                                    }
                                                }).filter(doc => doc._id !== this.state.doctorId && doc.name.toLowerCase().indexOf(this.state.filterDoctors ? this.state.filterDoctors.toLowerCase() : ' ') != -1).map(item => {
                                                    return ({
                                                        name: item.name,
                                                        value: item._id,
                                                        profilePicture: item.profilePicture,
                                                        username: item.username
                                                    })
                                                })}
                                                onChange={(item) => {
                                                    let doctorsList = this.state.doctorsList;
                                                    doctorsList = [...item]
                                                    this.setState({ doctorsList })
                                                }}
                                            />

                                            :
                                            "The doctor's list is empty".translate(this.props.lang)
                                    }
                                </FormGroup>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                {
                                    this.state.doctors && this.state.doctors.length && this.state.doctors.filter((item) => {
                                        if (item._id != this.state.doctorId) {
                                            return true;
                                        } else {
                                            return false;
                                        }
                                    }).length ?
                                        <Button color='primary'
                                            onClick={() =>
                                                this.checkDoctorsAvailable(this.state.doctorsList, this.state.doctorsModal)
                                            }>{'Add'.translate(this.props.lang)}</Button>
                                        :
                                        null
                                }
                                <Button color='primary' onClick={() => {
                                    this.setState({ doctorsModal: false })
                                }
                                }>{"Close".translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }
                {
                    this.state.error ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                        >
                            {this.state.error}
                        </ErrorModal>

                        :
                        null
                }
                {
                    this.state.wrongDate ?
                        <Modal isOpen={this.state.wrongDate} centered>
                            <ModalBody className="delete-modal">
                                <p className='message'>{'You can not pick date form the past'.translate(this.props.lang)}</p>
                            </ModalBody>
                            <ModalFooter className="buttons-right-blue">
                                <Button style={{ minWidth: 100 }} color='primary' onClick={() => this.setState({ wrongDate: !this.state.wrongDate })}>{'Pick again'.translate(this.props.lang)}</Button>
                            </ModalFooter>
                        </Modal>
                        : null
                }


                {
                    this.state.errorAdditionalDoctors ?

                        <ErrorModal lang={this.props.lang}
                            isOpen={this.state.errorAdditionalDoctors}
                            toggle={() => {

                                this.setState({ errorAdditionalDoctors: null })
                            }}

                        >
                            {
                                this.state.errorAdditionalDoctors && this.state.errorAdditionalDoctors.map((item, idx) => {
                                    return (
                                        <div>
                                            <span style={{ fontWeight: 600 }}>
                                                {item.doctorName}  {' - '}
                                            </span>

                                            {
                                                item.available ?
                                                    <span style={{ color: 'green' }}>{'Available'.translate(this.props.lang)}</span>
                                                    :
                                                    <span style={{ color: 'red' }}>{'Unavailable'.translate(this.props.lang)}</span>
                                            }

                                        </div>
                                    )
                                })

                            }
                        </ErrorModal>
                        :
                        null
                }

                {
                    this.state.showPatientNotes ?
                        <PatientNotesPreview
                            {...this.props}
                            isOpen={this.state.showPatientNotes}
                            items={this.state?.data?.patientNotes}
                            toggle={() => this.setState({ showPatientNotes: !this.state.showPatientNotes })}
                            showInModal={true}
                        />
                        :
                        null
                }

                {
                    this.state.wrongDateModal ?
                        <InfoModal
                            isOpen={this.state.wrongDateModal}
                            onClose={(item) => {
                                this.setState({
                                    wrongDateModal: null
                                })
                            }}
                            info={"This event has already occurred.".translate(this.props.lang)}
                            buttons={[
                                <Button
                                    // color='success'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.scheduleAdministrativeBooking(true);
                                    }}
                                >
                                    {"Save".translate(this.props.lang)}
                                </Button>,
                                <Button
                                    // color='danger'
                                    style={{ margin: 10, border: 'none' }}
                                    onClick={() => {
                                        this.setState({
                                            wrongDateModal: null,
                                            creatingEvent: null,
                                        })
                                    }}
                                >
                                    {'Go back'.translate(this.props.lang)}
                                </Button>,
                            ]}
                        />
                        :
                        null
                }

            </>


        )
    }
}

export default RescheduleAdministrativeBooking;